import { TChatAction, EChatsActionTypes } from '../../actions/chat';

export interface IOfferChatsState {
  isChatsEnabled: boolean;
  isChatOpened: boolean;
  chatId?: string;
  type?: 'open_phone' | 'open_message';
}

const initialState: IOfferChatsState = {
  chatId: undefined,
  isChatsEnabled: false,
  isChatOpened: false,
};

export function chatReducer(state: IOfferChatsState = initialState, action: TChatAction): IOfferChatsState {
  switch (action.type) {
    case EChatsActionTypes.StateReceived:
      return {
        ...state,
        isChatsEnabled: action.payload.enabled,
      };

    case EChatsActionTypes.OfferChatReceived:
      return {
        ...state,
        chatId: action.payload.chatId,
      };

    case EChatsActionTypes.OpenChat:
      return {
        ...state,
        isChatOpened: true,
        type: action.payload.type,
      };

    case EChatsActionTypes.CloseChat:
      return {
        ...state,
        isChatOpened: false,
        type: undefined,
      };

    default:
      return state;
  }
}
